/**
 * 碰撞 不维修原因
 */
export default function notRepairTypes(val) {
    let str = '';
    switch (val) {
    case 'NOT_REPAIR_TYPE_1':
        str = '价格原因';
        break;
    case 'NOT_REPAIR_TYPE_2':
        str = '回店保养';
        break;
    case 'NOT_REPAIR_TYPE_3':
        str = '未受损，暂时不修';
        break;
    case 'NOT_REPAIR_TYPE_4':
        str = '轻微剐蹭，暂时不修';
        break;
    case 'NOT_REPAIR_TYPE_5':
        str = '仅车损评估';
        break;
    case 'NOT_REPAIR_TYPE_6':
        str = '暂无零件';
        break;
    case 'NOT_REPAIR_TYPE_7':
        str = '选择修理厂维修';
        break;
    case 'NOT_REPAIR_TYPE_0':
        str = '其他';
        break;
    default:
        break;
    }
    return str;
}
